export const STALE_TIME = {
  FIVE_SECONDS: 1000 * 5,
  THIRTY_SECONDS: 1000 * 30,
  ONE_MINUTE: 1000 * 60,
  FIVE_MINUTES: 1000 * 60 * 5,
  FIFTEEN_MINUTES: 1000 * 60 * 15,
  THIRTY_MINUTES: 1000 * 60 * 30,
  ONE_HOUR: 1000 * 60 * 60,
  ONE_DAY: 1000 * 60 * 60 * 24,
  ONE_WEEK: 1000 * 60 * 60 * 24 * 7,
} as const

export const useSsrQueryCache = () => {
  const { $pinia } = useNuxtApp()
  return useQueryCache($pinia)
}
